<template>
    <div>
        
        <slot name="settings">
            
        </slot>
        
        <div
            v-bind:class="classes"
            v-bind:style="styles"
            v-on:click.stop="selectItem"
        >
            <div 
                v-if="showButtons" 
                class="item-buttons"
                v-bind:class="controlsClass"
                v-bind:style="controlsStyle"
            >
                <i v-if="!hideSort" class="fas fa-sort-up mdb-icon-btn edit" v-on:click.stop="moveItem(direction.up)"></i>
                <i v-if="!hideDelete" class="fa fa-times mdb-icon-btn delete" v-on:click.stop="deleteItem"></i>
                <i v-if="!hideSort" class="fas fa-sort-down mdb-icon-btn edit" v-on:click.stop="moveItem(direction.down)"></i>

                <i v-if="!locked" class="fas fa-lock-open mdb-icon-btn edit" v-on:click.stop="$emit('lock-item', true)"></i>
                <i v-else class="fas fa-lock mdb-icon-btn new" v-on:click.stop="$emit('lock-item', false)"></i>

            </div>
            <div 
                v-else 
                class="item-buttons"
                v-bind:class="controlsClass"
                v-bind:style="controlsStyle"
            >
                <i v-if="lockedByParent" class="locked-item fas fa-lock"></i>
                <i v-else-if="parentId !== null" class="unlocked-item fas fa-lock-open"></i>
            </div>

            <div>
                <slot></slot>
            </div>
        </div>        
    </div>
    
</template>

<script>
    import selectableItemMixin from '../Mixins/selectable-item';
    import resourceMixin from "../../../Util/Mixins/resources";
    import prompt from '../../../Util/prompt';
    import funcRepo from '../Util/functionRepository';

    export default {
        mixins: [resourceMixin, selectableItemMixin],
        name: 'template-item',
        created() {
            const vm = this;

            vm.subscriptionId = funcRepo.subscribe(() => vm.$emit('unselect-all', vm));
        },
        methods: {
            deleteItem() {
                const vm = this;

                prompt.promptWithIconV2(vm.resource('TemplateItem_DeleteItemPrompt_Title'), vm.resource('TemplateItem_DeleteItemPrompt_Body'), 'fa fa-exclamation-triangle text-danger')
                    .then(() => {
                        funcRepo.execute();
                        
                        vm.$nextTick(() => {
                            vm.$emit('delete-item', vm.metadata.index);
                        });
                    },
                    () => { /* Do nothing */ });
            },
            moveItem(direction) {
                const vm = this;
                const newIndex = direction === vm.direction.up ? vm.metadata.index-1 : vm.metadata.index+1;
                vm.$emit('move-item', { old: vm.metadata.index, new: newIndex });
            },
            selectItem() {
                funcRepo.execute();
                this.itemClicked = true;
                this.emitSelection('select-item', this.metadata);
            }
        },
        computed: {
            direction() {
                return {
                    up: 0,
                    down: 1
                };
            },
            lockedByParent() {
                return this.locked && this.isParent;
            },
            showButtons() {
                return !this.hideControls && !this.lockedByParent && this.parentId === null;
            }
        },
        props: {
            isSelected: {
                type: Boolean,
                required: true
            },
            parentId: {
                type: String,
                default: null
            },
            isParent: {
                type: Boolean,
                default: false
            },
            metadata: {
                type: Object,
                required: true
            },
            hideSort: {
                type: Boolean
            },
            hideDelete: {
                type: Boolean
            },
            hideControls: {
                type: Boolean
            },
            controlsClass: {
                type: String
            },
            controlsStyle: {
                type: String
            },
            classes: {
                type: String
            },
            styles: {
                type: String
            },
            locked: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                subscriptionId: null,
                itemClicked: false
            }
        },
        destroyed() {
            funcRepo.unsubscribe(this.subscriptionId);
        }
    };
</script>

<style scoped src="../Style/template-item.scss" lang="scss">
</style>
